export enum RecurringInvoiceSendStatus {
  SEND = 'Send',
  DRAFT = 'Draft',
  PENDING_REVIEW = 'Pending Review'
}
